import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import cx from 'classnames';
import { Droppable } from '@hello-pangea/dnd';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import DnDItem from './DnDItem';
import { visuallyHidden } from '@mui/utils';
import { getLight, getDark } from '../utils';
import { BOX } from './constants';

export var useStyles = makeStyles(function (theme) {
  var _ref;

  return _ref = {
    blockDnd: {
      width: '100%',
      paddingBottom: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(1),
      minHeight: 30,
      marginBottom: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
      borderWidth: 2,
      borderStyle: 'solid'
    },
    canDrop: {
      borderStyle: 'dashed'
    }
  }, _ref[BOX.sections + 'Container'] = {
    borderColor: getDark(theme) || theme.palette.secondary.dark
  }, _ref[BOX.rows + 'Container'] = {
    borderColor: getLight(theme) || theme.palette.secondary.light
  }, _ref[BOX.header + 'Container'] = {
    borderColor: theme.palette.primary.main
  }, _ref.iconTitle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexFlow: 'nowrap'
  }, _ref.title = theme.typography.subtitle1, _ref;
});

var Box = function Box(_ref2) {
  var items = _ref2.items,
      itemRenderer = _ref2.itemRenderer,
      dropZoneLabel = _ref2.dropZoneLabel,
      title = _ref2.title,
      Icon = _ref2.Icon,
      onChangeLayout = _ref2.onChangeLayout,
      itemButtonProps = _ref2.itemButtonProps,
      accessibility = _ref2.accessibility,
      md = _ref2.md;

  var classes = useStyles();
  var canDrag = R.equals(dropZoneLabel, BOX.rows) ? R.pipe(R.length, R.lt(1))(items) : R.T();

  return React.createElement(
    Grid,
    { item: true, xs: accessibility ? 4 : 12, md: md },
    React.createElement(
      'div',
      { className: classes.iconTitle },
      React.createElement(Icon, null),
      React.createElement(
        'span',
        { className: classes.title },
        title
      ),
      React.createElement(
        Typography,
        { style: visuallyHidden },
        title
      )
    ),
    React.createElement(
      Droppable,
      { droppableId: dropZoneLabel },
      function (provided, snapshot) {
        var _cx;

        return React.createElement(
          'div',
          {
            'data-testid': 'droppable-' + dropZoneLabel,
            ref: provided.innerRef,
            className: cx(classes.blockDnd, R.prop(dropZoneLabel + 'Container')(classes), (_cx = {}, _cx[classes.canDrop] = snapshot.isDraggingOver, _cx))
          },
          R.addIndex(R.map)(function (item, index) {
            return React.createElement(DnDItem, {
              key: item.id,
              index: index,
              item: item,
              itemRenderer: itemRenderer,
              dropZoneLabel: dropZoneLabel,
              onChangeLayout: onChangeLayout,
              itemButtonProps: itemButtonProps,
              canDrag: canDrag
            });
          })(R.values(items)),
          provided.placeholder
        );
      }
    )
  );
};

Box.propTypes = process.env.NODE_ENV !== "production" ? {
  items: PropTypes.array,
  itemRenderer: PropTypes.func,
  dropZoneLabel: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  Icon: PropTypes.object,
  onChangeLayout: PropTypes.func,
  putItem: PropTypes.func,
  itemButtonProps: PropTypes.object,
  accessibility: PropTypes.bool,
  md: PropTypes.number
} : {};

export default Box;